import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { abilitiesPlugin } from '@casl/vue';

Vue.use(CKEditor);
Vue.use(abilitiesPlugin, store.getters['auth/ability'], {
  useGlobalProperties: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,

  render: function(h) {
    return h(App);
  }
}).$mount('#app');
